export const AUTH_CONTACT_NUMBER = "+92 331 6300886";
